"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.WebsocketImp = void 0;
const Settings_1 = require("../base/kernel/Settings");
const SocketClient_1 = require("../base/port/SocketClient");
const is_blank_1 = __importDefault(require("@sedan-utils/is-blank"));
const lodash_1 = require("lodash");
const socket_io_client_1 = __importDefault(require("socket.io-client"));
function delay(ms) {
    return new Promise(resolve => setTimeout(resolve, ms));
}
function* fibonacci() {
    let a = 0;
    let b = 1;
    while (true) {
        yield a;
        [a, b] = [b, a + b];
    }
}
class WebsocketImp extends SocketClient_1.SocketClient {
    constructor(authStore) {
        super(authStore);
        this.authStore = authStore;
        this.socketName = "websocket";
        this.prevMS = 0;
        this.fib = fibonacci();
        this.MAX_TIME = 5 * 60 * 1000;
        this.setup();
    }
    setup() {
        const token = this.authStore.state.brainToken;
        const guest_user_key = this.authStore.state.guestToken;
        const auth = token ? { token } : { guest_user_key };
        if ((0, is_blank_1.default)(token) && (0, is_blank_1.default)(guest_user_key))
            return;
        const socket = (0, socket_io_client_1.default)(Settings_1.settings.WS, {
            reconnection: false,
            transports: ["websocket"],
        });
        // eslint-disable-next-line
        const patch = require("socketio-wildcard")(socket_io_client_1.default.Manager);
        patch(socket);
        this.socket = socket;
        socket.on("connect", () => {
            console.log("socket connect");
            socket.emit("authentication", auth);
            socket.on("authenticated", (msg) => {
                console.log("authenticated", msg);
                socket.on("*", (msg) => {
                    const topic = (0, lodash_1.get)(msg, "data.1.key.topic");
                    if (topic) {
                        socket.emit("acknowledge", { topic });
                    }
                    // console.log("sending ack");
                });
            });
        });
        this.socket.on("connect_timeout", (timeout) => {
            console.error("socket connect_timeout", timeout);
            this.socket = null;
        });
        socket.on("disconnect", (reason) => {
            console.log("socket disconnect", reason);
            this.reconnect();
        });
        socket.on("connect_error", (error) => {
            console.log("socket connect_error", error);
            this.reconnect();
        });
        socket.on("error", (error) => {
            console.log("socket error", error);
            this.reconnect();
        });
    }
    socketOn(topic, listener) {
        if (!(0, is_blank_1.default)(this.socket)) {
            this.socket.on(topic, listener);
        }
    }
    socketOff(topic, listener) {
        if (!(0, is_blank_1.default)(this.socket)) {
            this.socket.off(topic, listener);
        }
    }
    socketDisconnect() {
        if (!(0, is_blank_1.default)(this.socket)) {
            this.socket.stop?.();
        }
        this.socket = null;
    }
    async socketReconnect() {
        if (this.prevMS < this.MAX_TIME) {
            const nextNum = this.fib.next().value;
            this.prevMS = nextNum * 1000;
        }
        else {
            this.prevMS = this.MAX_TIME;
        }
        await delay(this.prevMS);
        this.setup();
    }
}
exports.WebsocketImp = WebsocketImp;
